import { Component, forwardRef, input, OnDestroy, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';

import { Subscription, tap } from 'rxjs';

import { MS_PER_MIN } from '@shared/core';

// TODO: rename it
@Component({
  selector: 'tablesready-duration',
  templateUrl: './duration.component.html',
  styleUrls: ['./duration.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DurationComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: DurationComponent,
      multi: true,
    },
  ],
})
export class DurationComponent implements OnInit, OnDestroy, ControlValueAccessor, Validator {
  minDuration = input<number>(0);
  duration = 0;
  durationInMinutes = 0;
  disabled = false;
  control: FormControl = null;
  private onChangeMethod: (value: number | string | boolean) => unknown;
  private onTouchedMethod: () => unknown;
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.control = this.fb.control(null, []);
    const valueSubscription = this.control.valueChanges.pipe(
      tap(value => {
        if (value === null) {
          if (this.onChangeMethod) {
            this.onChangeMethod(this.duration);
          }
          return;
        }

        this.durationInMinutes = value;
        this.duration = this.durationInMinutes * MS_PER_MIN;
        if (this.onChangeMethod) {
          this.onChangeMethod(this.duration);
        }
      })
    )
      .subscribe();
    this.subscriptions.add(valueSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  registerOnChange(onChangeMethod: () => unknown): void {
    this.onChangeMethod = onChangeMethod;
  }

  registerOnTouched(onTouchedMethod: () => unknown): void {
    this.onTouchedMethod = onTouchedMethod;
  }

  // Expects value in milliseconds
  writeValue(value: number): void {
    this.duration = value || 0;
    this.durationInMinutes = Math.round(this.duration / MS_PER_MIN);
    this.control.setValue(this.durationInMinutes, {emitEvent: false});
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  validate(): ValidationErrors | null {
    if (this.control.value === null) {
      return { required: true };
    }

    return this.control?.errors || null;
  }
}
